<template>
  <div class="row examples">
    <div class="col-3">
      <div class="snippet" data-title="dot-flashing">
        <div class="stage">
          <div class="dot-flashing"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.row {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 3rem;
}
.stage {
    display: flex;
    align-items: center;
    justify-content: center;
}
.dot-flashing {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background-color: rgb(129, 0, 0);
  color: rgb(129, 0, 0);
  animation: dot-flashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}
.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.dot-flashing::before {
  left: -50px;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background-color: rgb(129, 0, 0);
  color: rgb(129, 0, 0);
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 0s;
}
.dot-flashing::after {
  left: 50px;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background-color: rgb(129, 0, 0);
  color: rgb(129, 0, 0);
  animation: dot-flashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dot-flashing {
  0% {
    background-color: rgb(129, 0, 0);
  }
  50%,
  100% {
    background-color: rgba(129, 0, 0, 0.2);
  }
}
</style>
